module.exports = __webpack_public_path__ + "static/media/grip-vertical.f1a8c028.svg";